export default __webpack_public_path__ + "static/SiemensSans-Roman-321a7f8d217cd723f8507a646cd1c82c.woff";